import HandsonTable from "../../../../components/handsonTable/handsonTable";
import { connect } from "react-redux";
import each from "lodash/each";
import columnCustomizer from "../../../rawDataTableModule/smartComponents/columnCustomizer";

export default connect(state => {
  const { tableInfo } = state.studioInfo.membershipActivityRevenue;
  const currency = tableInfo.currency;
  const columns = tableInfo.columns || [];
  columnCustomizer(tableInfo.colHeaders, columns, currency);
  const hiddenColumns = {
    columns: []
  };
  let colHeaders = tableInfo.colHeaders;
  const tableConfiguration = tableInfo.tableConfiguration || { linkColumns: [] };

  each(tableConfiguration.linkColumns, colName => {
    const colIndex = tableInfo.colHeaders.indexOf(colName);
    hiddenColumns.columns.push(colIndex + 1);
  });

  return {
    data: tableInfo.data,
    colHeaders,
    hiddenColumns,
    columns,
    fragmentSelection: true,
    columnSorting: true,
    filters: true,
    width: 630,
    height: "auto",
    stretchH: "all"
    // dropdownMenu: [
    //   "filter_by_condition", //
    //   "---------",
    //   "filter_by_value",
    //   "filter_action_bar"
    // ]
  };
})(HandsonTable);
